import { Record } from 'immutable';
import { schema } from 'normalizr';

export const IntrusionSensorConfiguration = new Record({
  id: undefined,
  site: undefined,
  delay_before_relays_power_off_seconds: undefined,
  relays_to_power_off: [],
  relays_to_power_on: [],
  automatic_rearm_time_minutes: undefined,
  automatic_alarm_cancel_time_minutes: undefined,
});

export const intrusionSensorConfigurationSchema = new schema.Entity('intrusionSensorConfigurations');
